const HelpButton = () => {
    return (
        <span className="help"><a className="button" href="/help">Help</a></span>
    );
};

export default HelpButton;